module.exports = __webpack_public_path__ + "static/media/features_video_still_2.af8577c4.jpg";